import React from "react";
import {
  Building2,
  HeartPulse,
  Ear,
  Smile,
  Eye,
  Activity,
  Apple,
  Brain,
  FlaskConical,
  HousePlus,
  ShieldPlus,
  Baby,
  Users,
  Accessibility,
  BriefcaseBusinessIcon,
} from "lucide-react";
import { motion } from "framer-motion";

const Plans = () => {
  const services = [
    {
      title: "Hospitals",
      icon: <Building2 size={22} className="text-royalBlue" strokeWidth={1.5} />,
    },
    {
      title: "Super Specialty Clinics",
      icon: <HeartPulse size={22} className="text-royalGreen" strokeWidth={1.5} />,
    },
    {
      title: "ENT Specialists",
      icon: <Ear size={22} className="text-royalBlue" strokeWidth={1.5} />,
    },
    {
      title: "Dentists",
      icon: <Smile size={22} className="text-royalGreen" strokeWidth={1.5} />,
    },
    {
      title: "Eye Care Clinics",
      icon: <Eye size={22} className="text-royalBlue" strokeWidth={1.5} />,
    },
    {
      title: "Physiotherapy",
      icon: <Activity size={22} className="text-royalGreen" strokeWidth={1.5} />,
    },
    {
      title: "Nutritionists",
      icon: <Apple size={22} className="text-royalBlue" strokeWidth={1.5} />,
    },
    {
      title: "Therapists",
      icon: <Brain size={22} className="text-royalGreen" strokeWidth={1.5} />,
    },
    {
      title: "Diagnostic Labs",
      icon: <FlaskConical size={22} className="text-royalBlue" strokeWidth={1.5} />,
    },
    {
      title: "Homecare Services",
      icon: <HousePlus size={22} className="text-royalGreen" strokeWidth={1.5} />,
    },
    {
      title: "Nursing Support",
      icon: <ShieldPlus size={22} className="text-royalBlue" strokeWidth={1.5} />,
    },
    {
      title: "Babysitting Support",
      icon: <Baby size={22} className="text-royalGreen" strokeWidth={1.5} />,
    },
    {
      title: "Elderly Care",
      icon: <Users size={22} className="text-royalBlue" strokeWidth={1.5} />,
    },
    {
      title: "Rehabilitation Support",
      icon: <Accessibility size={22} className="text-royalGreen" strokeWidth={1.5} />,
    },
  ];

  return (
    <motion.section
      id="Services"
      initial={{ opacity: 0, x: 40 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{
        duration: 0.8,
        ease: "easeIn"
      }}
      viewport={{ once: true, amount: 0.2 }}
      className="bg-white py-[6vw] lg:py-[3vw] overflow-hidden relative"
    >
      {/* Background Blur */}
      <div className="absolute top-[-10%] left-[-5%] w-[200px] h-[200px] lg:w-[300px] lg:h-[300px] bg-[#4169E110] rounded-full blur-3xl"></div>
      <div className="absolute bottom-[-10%] right-[-5%] w-[200px] h-[200px] lg:w-[300px] lg:h-[300px] bg-[#0E9F6E10] rounded-full blur-3xl"></div>

      <div className="max-w-[1450px] mx-auto px-[5%] relative z-10">
        {/* Heading Section */}
        <div className="text-center">
          <div className="flex justify-center mb-8 md:mb-10">
  <div className="inline-flex items-center gap-2 bg-gradient-to-r from-royalBlue/10 to-royalBlue/5 backdrop-blur-sm rounded-full px-5 py-2 sm:px-6 md:px-7 sm:py-2 md:py-3 border border-royalBlue/20 shadow-lg">
    <BriefcaseBusinessIcon size={18} className="text-royalGreen" />
    <p className="font-poppins font-semibold text-royalBlue text-sm sm:text-base md:text-lg tracking-wide uppercase whitespace-nowrap">
      SERVICES WE HELP WITH
    </p>
  </div>
</div>

          <h2 className="mt-5 font-poppins font-[700] text-darkblue leading-[1.25] text-[7vw] sm:text-[5.5vw] md:text-[4vw] lg:text-[3vw]">
            Healthcare Services Available Through Livmo
          </h2>

          <p className="mt-5 max-w-[950px] mx-auto text-text1/90 leading-[1.7] font-poppins text-[3.5vw] sm:text-[2.2vw] md:text-[1.4vw] lg:text-[1.05vw]">
            Livmo connects employees with 2500+ verified healthcare providers
            across India, helping corporate employees access trusted healthcare
            support quickly, safely, and efficiently.
          </p>
        </div>

        {/* Highlight Banner */}
        <div className="mt-[10vw] lg:mt-[5vw] bg-gradient-to-r from-royalBlue to-royalGreen rounded-2xl lg:rounded-[2vw] p-6 sm:p-8 lg:p-[3%] shadow-2xl">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6 lg:gap-8">
            <div className="text-center lg:text-left">
              <h3 className="text-white font-poppins font-[700] leading-[1.35] text-[6vw] sm:text-[4.5vw] md:text-[3vw] lg:text-[2vw]">
                2500+ Verified Healthcare Providers Across India
              </h3>
              <p className="text-white/90 mt-3 lg:mt-4 leading-[1.7] font-poppins max-w-[800px] text-[3.2vw] sm:text-[2vw] md:text-[1.3vw] lg:text-[1vw]">
                Hospitals, clinics, diagnostics, therapists, rehabilitation,
                homecare, and specialized healthcare support — all coordinated
                through Livmo.
              </p>
            </div>
            <div className="flex items-center justify-center min-w-[140px] min-h-[140px] lg:min-w-[180px] lg:min-h-[180px] rounded-full bg-white/10 backdrop-blur-md border border-white/20">
              <h4 className="text-white font-poppins font-[700] text-center leading-[1.2] text-[8vw] sm:text-[6vw] md:text-[4vw] lg:text-[2.5vw]">
                2500+
                <span className="block text-[3vw] sm:text-[2vw] md:text-[1.5vw] lg:text-[1vw] font-[500] mt-1 lg:mt-2">
                  Providers
                </span>
              </h4>
            </div>
          </div>
        </div>

        {/* Grid Heading */}
        <div className="text-center mt-[12vw] lg:mt-[5vw] mb-8 lg:mb-10">
          <div className="inline-block">
            <div className="flex justify-center mb-4">
              <div className="h-px w-12 bg-gradient-to-r from-transparent via-royalBlue to-transparent"></div>
            </div>
            <h3 className="font-poppins font-[600] text-darkblue text-2xl sm:text-3xl md:text-4xl lg:text-[2.2rem] tracking-tight">
              Comprehensive Care Categories
            </h3>
            <p className="text-text1/70 mt-2 max-w-2xl mx-auto font-poppins text-sm sm:text-base">
              Everything you need, all in one place — from diagnosis to recovery
            </p>
            <div className="flex justify-center mt-4">
              <div className="h-px w-12 bg-gradient-to-r from-transparent via-royalGreen to-transparent"></div>
            </div>
          </div>
        </div>

       {/* Vercel-style Grid */}
<div className="relative mt-8">
  {/* Top-left plus */}
  <div className="absolute top-0 left-0 -translate-x-1/2 -translate-y-1/2 w-8 h-8 z-10">
    <div className="absolute top-1/2 left-0 right-0 h-px bg-gray-400"></div>
    <div className="absolute left-1/2 top-0 bottom-0 w-px bg-gray-400"></div>
  </div>

  {/* Bottom-right plus */}
  <div className="absolute bottom-0 right-0 translate-x-1/2 translate-y-1/2 w-8 h-8 z-10">
    <div className="absolute top-1/2 left-0 right-0 h-px bg-gray-400"></div>
    <div className="absolute left-1/2 top-0 bottom-0 w-px bg-gray-400"></div>
  </div>

  <div className="border border-green-200 overflow-hidden">
    <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-gray-100/60">
      {services.map((service, idx) => (
        <div
          key={idx}
          className="bg-white flex items-center gap-1.5 sm:gap-3 hover:bg-green-50 transition-colors duration-200
                     p-2 sm:p-4"
        >
          {/* Icon — smaller and no wrapper scaling trick on mobile */}
          <div className="flex-shrink-0 w-6 h-6 sm:w-9 sm:h-9 rounded-md sm:rounded-lg bg-gradient-to-br from-gray-50 to-white shadow-sm flex items-center justify-center border border-gray-100">
            <span className="[&>svg]:w-3.5 [&>svg]:h-3.5 sm:[&>svg]:w-[22px] sm:[&>svg]:h-[22px]">
              {service.icon}
            </span>
          </div>

          {/* Text — tighter font on mobile, normal on sm+ */}
          <h4 className="font-poppins font-medium text-darkblue leading-tight min-w-0
                         text-[10px] sm:text-sm md:text-base">
            {service.title}
          </h4>
        </div>
      ))}
    </div>
  </div>
</div>

        {/* Bottom Info */}
        <div className="mt-[6vw] lg:mt-[3vw] text-center px-4">
          <p className="text-text1/90 leading-[1.8] max-w-[1000px] mx-auto font-poppins text-[3.2vw] sm:text-[2vw] md:text-[1.3vw] lg:text-[1vw]">
            Livmo simplifies healthcare access for corporate employees by
            helping them discover, compare, and coordinate trusted healthcare
            services without the stress of searching independently.
          </p>
        </div>
      </div>
    </motion.section>
  );
};

export default Plans;